<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="10"
    viewBox="0 0 9 10"
    fill="none"
  >
    <path
      d="M5.79495 9.9931C5.79495 9.9931 4.79444 6.06247 3.69064 5.4069C2.58684 4.75133 0.450707 5.07947 0.450707 5.07947C0.450707 5.07947 2.46472 4.29558 3.09285 3.17594C3.72099 2.0563 3.69064 0.799894 3.69064 0.799894C3.69064 0.799894 4.16562 1.93716 5.26942 2.59273C6.37322 3.2483 8.50935 2.92016 8.50935 2.92016C8.50935 2.92016 6.49534 3.70405 5.86721 4.82369C5.23907 5.94333 5.79495 9.9931 5.79495 9.9931Z"
      fill="url(#paint0_radial_58182_10723)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_58182_10723"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(4.48005 3.99978) rotate(-22.716) scale(11.2772 11.0023)"
      >
        <stop stop-color="white" />
        <stop
          offset="1"
          stop-color="#F186FF"
        />
      </radialGradient>
    </defs>
  </svg>
</template>